export default __webpack_public_path__ + "static/kb_1_6-d831fa32e259b49c9c73c5036cbefca9.jpeg";